import { render, staticRenderFns } from "./ServerDown.vue?vue&type=template&id=01fd7b1d&scoped=true&"
import script from "./ServerDown.vue?vue&type=script&lang=js&"
export * from "./ServerDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fd7b1d",
  null
  
)

export default component.exports